import React, { useEffect, useState } from 'react';
import CommonModal from '@components/common/CommonModal';
import { getChildGender, getChildProfileDetails, getUpdatedToken, sendChildOTPViaAadhaar, updateChildData } from '@services/childApiServices';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { updateChild } from '@store/actions/beneficiaryAction';
import { RootState } from '@store/reducers';
import { errorLogger } from '@utils/applicationLogUtils';
import { benef_error_const } from '@constants/beneficiaryConstant';
import { CHILD_CONSTANTS, CHILD_ERROR_MESSAGES, child_otp_const, CHILD_SUCCESS_MESSAGES } from './childConstants';
import ChildAadhaarKYCModal from './CreateAndVerifyModal/ChildAadhaarKYCModal';
import ChildOtpModal from '../CreateNewChild/ChildOtpModal';
import { 
  handleError, 
  mapGenderCodeToName, 
  findGenderIdByName, 
  formatAbhaNumber, 
  createChildKYCPayload,
  validateFileForUpload,
  createFileFormData,
  base64ToFile,
  getRefreshedChildProfile,
} from '@utils/childUtils';
import { useNavigate } from 'react-router-dom';
import { updateForm } from '@store/actions/userManagementAction';
import axios from '@utils/axiosExt';
import endpoints from '@config/endpoints';
import Auth from "../../../../utils/auth";


interface ChildKycModalProps {
  currentChild: any;
  flow: string;
  showChildKycModal: boolean;
  isChildKycLogin: boolean;
  onClose: () => void;
}

const ChildKycModal = ({ currentChild, flow, showChildKycModal, isChildKycLogin, onClose } : ChildKycModalProps) => {
  const dispatch = useDispatch();
  const userId = localStorage.getItem('userId');
  const navigate = useNavigate();
  const childToken = useSelector((state: RootState) => state.beneficiary?.childToken);

  const [showChildAadhaarKycModal, setShowChildAadhaarKycModal] = useState<boolean>(false);
  const [showChildModal, setShowChildModal] = useState<boolean>(false);
  const [isChildLogin, setIsChildLogin] = useState<boolean>(false);
  const [aadhaarTxnId, setAadhaarTxnId] = useState<string>('');
  const [otpResponseMessage, setOtpResponseMessage] = useState<string>('');
  const [aadhaarError, setAadhaarError] = useState<boolean>(false);
  const [aadhaarMessage, setAadhaarMessage] = useState<string>('');
  const [showSpinner, setAadharShowSpinner] = useState<boolean>(false);
  const [otpResponse, setOtpResponse] = useState<any>();
  const [childGenderRes, setChildGenderRes] = useState<any>();
  const storeUserId = localStorage.getItem('userId');
  const childGenderOptions = localStorage.getItem('childGenderOptions');

    useEffect(() => {
        setShowChildModal(showChildKycModal);
        setIsChildLogin(isChildKycLogin);
    }, [showChildKycModal, isChildKycLogin]);

    const fetchGender = async () => {
      if (storeUserId && childGenderOptions) {
        const decodedGenderOptions = JSON.parse(decodeWithKeyAndShift(childGenderOptions));
        setChildGenderRes(decodedGenderOptions);
      }else{
        const genderResponse = await getChildGender();
        localStorage.setItem('childGenderOptions', encodeWithKeyAndShift(JSON.stringify(genderResponse)));
        setChildGenderRes(genderResponse?.data);
      }
    }

    useEffect(() => {
      fetchGender();
    },[]);

  const handleModalBackButton = () => {
    if (showChildModal && isChildLogin) {
      setShowChildModal(false);
      onClose();
    } else if (showChildModal && !isChildLogin) {
      setShowChildModal(false);
      setShowChildAadhaarKycModal(true);
    } else if (showChildAadhaarKycModal) {
      setShowChildModal(true);
      setIsChildLogin(true);
      setShowChildAadhaarKycModal(false);
    } else {
      setShowChildAadhaarKycModal(true);
      setShowChildModal(false);
    }
  };

  const handleOtpSubmit = (otp: any, response: any, isChildLogin: any) => {
    if (isChildLogin) {
      setOtpResponse(response);
      setIsChildLogin(false);
      setShowChildModal(false);
      setShowChildAadhaarKycModal(true);
    } else {
      setShowChildModal(false);
      setShowChildAadhaarKycModal(false);
      let toastMessage;
      if (response?.authResult === CHILD_CONSTANTS.SUCCESS) {
        toastMessage = CHILD_SUCCESS_MESSAGES.CHILD_KYC_SUCCESS;
        updateChildKYCDetails();
      } else {
        toastMessage = CHILD_ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      }
      toast.success(toastMessage, {
        position: "top-center"
      });
    }
  };

  const handleChildKYC = async (aadhaarNumber: any) => {
    try {
      const data = {
        aadhaar: aadhaarNumber,
        token: childToken,
      };
      const response = await sendChildOTPViaAadhaar(data);
      const decodedData = JSON.parse(decodeWithKeyAndShift(response?.data));
      const result = decodedData;
      
      if (result.txnId) {
        setOtpResponseMessage(result?.message);
        setAadhaarTxnId(result.txnId);
        setAadharShowSpinner(false);
        return true;
      } else if (result?.message?.includes(child_otp_const.runtimeError)) {
        handleError(`${result?.code} - ${result.message}`, benef_error_const.urlNotFound);
      } else if (result?.message?.includes(child_otp_const.seconds30)) {
        handleError(result?.message);
      } else if (result?.message?.includes(child_otp_const.multipleOtps)) {
        handleError(result?.message, benef_error_const.multipleOTP);
      } else if (result?.message?.includes(child_otp_const.missingCredentials)) {
        handleError(`${result?.code} - ${result?.description}`);
      } else if (result?.message?.includes(child_otp_const.tooManyRequests)) {
        handleError(`${result?.message}`);
      } else if (result?.message?.includes(child_otp_const.gatewayUnavailable)) {
        handleError(result?.message);
      } else if (result?.loginId?.includes(child_otp_const.invalidLoginId)) {
        handleError(result?.loginId, benef_error_const.provideCorrectAadhaar);
      } else if (result?.loginHint?.includes(child_otp_const.invalidLoginHint)) {
        handleError(result?.loginHint, CHILD_ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      } else {
        setAadhaarError(true);
        setAadharShowSpinner(false);
        setAadhaarMessage(result.message);
      }
      setAadharShowSpinner(false);
      return false;
    } catch (error: any) {
      setAadhaarError(true);
      errorLogger(error?.response?.data || error?.response || error);
      return false;
    }
  };

  const getUpdatedChildDetails = async () => {
    try {
      if (!otpResponse?.refreshToken) return null;
      
      return await getRefreshedChildProfile(
        otpResponse.refreshToken,
        getUpdatedToken,
        getChildProfileDetails,
        decodeWithKeyAndShift
      );
    } catch (error: any) {
      dispatch(updateChild('isKYCLoading', false));
      errorLogger(error?.response?.data || error?.response || error);
      return null;
    }
  }

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files && event.target.files[0];
    if (!selectedFile) return;

    const validation = validateFileForUpload(selectedFile);
    if (!validation.isValid) {
      return;
    }

    const formData = createFileFormData(selectedFile);
    dispatch(updateForm("file", formData));
    return formData;
  };

  const updateChildProfile = async (kycPhoto: any, childBenfID: any) => {
    try {
      if (!kycPhoto) return;

      const file = await base64ToFile(kycPhoto);
      if (!file) {
        return;
      }

      const uploadEvent = {
        target: { files: [file] }
      };

      const formData = await handleFileChange(uploadEvent as unknown as React.ChangeEvent<HTMLInputElement>);
      if (formData instanceof FormData) {
        formData.append("imageType", "beneficiary_profile");
        formData.append("objectId", childBenfID);
        await axios.post(`${endpoints.beneficiaryImageUpload}`, formData, Auth.loggedInWithMultipart());
      }
    } catch (error: any) {
      dispatch(updateChild('isKYCLoading', false));
      errorLogger(error?.response?.data || error?.response || error);
    }
  }

  const updateChildKYCDetails = async () => {
    try {
      dispatch(updateChild('isKYCLoading', true));
      const updatedChildDetails = await getUpdatedChildDetails();
      
      const childGender = mapGenderCodeToName(updatedChildDetails?.gender);
      const childGenderId = findGenderIdByName(childGenderRes, childGender);
      
      const formattedAbha = updatedChildDetails?.ABHANumber 
        ? formatAbhaNumber(updatedChildDetails.ABHANumber) 
        : currentChild?.bal_abha_id;
      
      const payload = createChildKYCPayload(
        updatedChildDetails,
        currentChild,
        childGenderId,
        formattedAbha,
        userId
      );
      
      const response = await updateChildData(payload);
      if (response) {
         dispatch(updateChild('isKYCLoading', false));
         navigate("/beneficiaries");
         dispatch(updateChild('isKYCVerified', true));
      }
      await updateChildProfile(updatedChildDetails?.kycPhoto, currentChild?.benef_id);
    } catch (error: any) {
      dispatch(updateChild('isKYCLoading', false));
      errorLogger(error?.response?.data || error?.response || error)
    }
  };

  const handleKYCSubmit = async (aadhaarNumber: any) => {
    const isValid = await handleChildKYC(aadhaarNumber);
    if (isValid) {
      setShowChildModal(true);
      const kycDetails = {
        aadhaarNumber: aadhaarNumber,
      }
      dispatch(updateChild('childKYCDetails', kycDetails));
    }
  };

  const handleCloseModal = (flow: string) => { 
    if(flow === 'close') {
        setShowChildModal(false); 
        setShowChildAadhaarKycModal(false); 
    } else {
        setShowChildAadhaarKycModal(false); 
    }
    onClose();
  }

  return (
    <>
      {showChildAadhaarKycModal && (
        <ChildAadhaarKYCModal
          showChildAadhaarKycModal={showChildAadhaarKycModal}
          handleCloseModal={() => handleCloseModal('')}
          handleModalBackButton={handleModalBackButton}
          handleFinalProceed={handleKYCSubmit}
          handleSkipKyc={() => { }}
          flow={flow}
        />
      )}
      {showChildModal && (
        <CommonModal
          show={showChildModal}
          handleClose={() => handleCloseModal('close')}
          handleCustomBackButton={handleModalBackButton}
          conditionalClass="modal_component dynamic_form_field child_kyc_modal"
          showCustomHeader={true}
          showButtonText={true}
          title=""
          size="md"
          footer={<></>}
        >
          <div className="child_otp_container">
            <ChildOtpModal
              otpLabel={CHILD_CONSTANTS.CHILD_OTP_LABEL}
              onClickSubmit={handleOtpSubmit}
              header={CHILD_CONSTANTS.CHILD_OTP}
              flow={'create'}
              showOtpSpinner={false}
              isChildKYC={true}
              isChildLogin={isChildLogin}
              aadhaarTxnId={aadhaarTxnId}
              aadhaarOtpResponseMessage={otpResponseMessage}
            />
          </div>
        </CommonModal>
      )}
    </>
  );
};

export default ChildKycModal;